/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { CoverageCalculatorMessage } from "../../../messages";
import {
  FormatMoney,
  getAllInfoByISO,
} from "@vlinder-web/pricing-powerpuff-module-react";
import fhpCalcConfig from "../../../config/fhpCalculator.config.json";

export const triggerRiskCapitalPremium = (lifeCycle: any) => {
  const message = lifeCycle?.fsm?.message as CoverageCalculatorMessage;
  // @ts-ignore
  const countryFound = fhpCalcConfig[message.country];
  if (!countryFound) {
    throw Error(`unsupported country ${message.country} for this product`);
  }
  const format = new FormatMoney({ decimals: 2 });
  const result: any = {
    country: message.country,
    premium: {
      raw: message.premium,
      formatted: format.from(message.premium, {
        symbol: getAllInfoByISO(message.country)?.symbol,
      }),
    },
    policyOptions: [...(countryFound.policyOptions || [])],
  };
  if (result) {
    result?.policyOptions?.forEach((opt: any, opti: number) => {
      const rol = opt.rolPct;

      let basePremium = message.premium;

      if (message?.platformCharge?.raw) {
        basePremium -= message.platformCharge.raw;
      }
      if (message?.insuranceProviderCharge?.raw) {
        basePremium -= message.insuranceProviderCharge.raw;
      }
      console.log("Basepremium",basePremium)
      
      const coverage = basePremium / (rol/100);
      opt.coverage = {
        raw: coverage,
        formatted: format.from(coverage, {
          symbol: getAllInfoByISO(message.country)?.symbol,
        }),
      };

      opt.premium = {
        raw: message.premium,
        formatted: format.from(message.premium, {
          symbol: getAllInfoByISO(message.country)?.symbol,
        }),
      };
      
      opt?.triggeringParams?.forEach((tp: any, tpi: number) => {
        const tpCoverage = coverage * (tp.coveragePct / 100);
        tp.coverage = {
          raw: tpCoverage,
          formatted: format.from(tpCoverage, {
            symbol: getAllInfoByISO(message.country)?.symbol,
          }),
        };
      });
    });
  }
  message.riskCapitalPremium = result;
  return true;
};
